<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            {{ nomeDep.descricao }}
          </h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <base-button
                  type="info"
                  class="animation-on-hover"
                  @click="voltarF()"
                  ><i class="tim-icons icon-minimal-left"></i>
                  Voltar</base-button
                >
              </div>
              <div
                class="d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div>
                  <modal :show.sync="adicionarModelo">
                    <template slot="header">
                      <h4 class="modal-title" id="exampleModalLabel">
                        Adicionar Modelo de Escala
                      </h4>
                    </template>
                    <div class="container">
                      <div class="row">
                        <div class="col-12">
                          <h5 class="text-left">
                            <strong>Departamento:</strong>Departamento teste
                          </h5>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-3 text-left d-flex flex-row">
                          <base-input
                            label="Código"
                            type="text"
                            v-model="demitir.data"
                          >
                          </base-input>
                        </div>
                        <div class="col-9 text-left d-flex flex-row">
                          <base-input
                            label="Descrição"
                            class="w-100"
                            type="text"
                            v-model="demitir.data"
                          >
                          </base-input>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 text-left">
                          <label
                            for="postoTrabalho"
                            class="form-label  text-left w-100"
                            >Quantidade de colunas</label
                          >
                          <el-select
                            class="select-success pagination-select w-100"
                            id="postoTrabalho"
                            v-model="horarioSelecionado"
                          >
                            <el-option
                              class="select-success"
                              label="2"
                              value="2"
                              selected
                              >2</el-option
                            >
                            <el-option
                              class="select-success"
                              label="4"
                              value="4"
                              >4</el-option
                            >
                            <el-option
                              class="select-success"
                              label="6"
                              value="6"
                              >6</el-option
                            >
                          </el-select>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 text-left">
                          <label class="col-form-label mb-0"
                            >Selecione os dias do horário</label
                          >
                          <div class="mt-0">
                            <base-checkbox class="mt-0"
                              >Todos os dias</base-checkbox
                            >
                          </div>
                          <div
                            class="d-flex flex-row w-100 justify-content-between"
                          >
                            <base-checkbox class="mt-0">seg</base-checkbox>
                            <base-checkbox class="mt-0">ter</base-checkbox>
                            <base-checkbox class="mt-0">qua</base-checkbox>
                            <base-checkbox class="mt-0">qui</base-checkbox>
                            <base-checkbox class="mt-0">sex</base-checkbox>
                            <base-checkbox class="mt-0">sab</base-checkbox>
                            <base-checkbox class="mt-0">dom</base-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>
                    <template slot="footer">
                      <base-button
                        type="danger"
                        @click="dialogHorarioLimite = false"
                        >Fechar</base-button
                      >
                      <base-button type="success">Salvar</base-button>
                    </template>
                  </modal>
                </div>
              </div>
            </div>
            <el-table :data="queriedData">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column :min-width="150" align="right" label="Ações">
                <div slot-scope="props">
                  <el-tooltip
                    content="Copiar Escala"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click.native="handleCopy(props.$index, props.row)"
                      class="edit btn-link"
                      type="primary"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-single-copy-04"></i>
                    </base-button>
                  </el-tooltip>

                  <el-tooltip
                    content="Editar"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click.native="handleEdit(props.$index, props.row)"
                      class="edit btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                  </el-tooltip>

                  <el-tooltip
                    content="Excluir"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click.native="handleDelete(props.$index, props.row)"
                      class="remove btn-link"
                      type="danger"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-simple-remove"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="font-weight-normal">
                Mostrando de {{ from + 1 }} a {{ to }} no total de
                {{ total }} escalas.
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="modalCopiarEscala">
      <template slot="header">
        <h4 class="modal-title" id="modalCopiarEscala">
          Copiar Modelo de Escala
        </h4>
      </template>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h5 class="text-left m-0">
              <strong>Escala selecionada:</strong>
              {{ copiaEscalaSelecionada.descricao }}
            </h5>
            <label
              for="postoTrabalho"
              class="form-label  text-left w-100"
              :class="erros.departamentos === true ? 'text-danger' : ''"
              >Departamentos:</label
            >
            <el-select
              multiple
              class="select-success pagination-select w-100"
              :class="erros.departamentos === true ? 'has-danger' : ''"
              size="large"
              v-model="copiaDepartamentosSelecionados"
              collapse-tags
              placeholder="Selecione as opções"
            >
              <el-option
                v-for="option in listDepartamentos"
                class="select-info"
                :value="option.id"
                :label="option.descricao"
                :key="option.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button type="danger" @click="modalCopiarEscala = false"
          >Fechar</base-button
        >
        <base-button type="success" @click="salvarCopiaEscala()"
          >Salvar</base-button
        >
      </template>
    </modal>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import users from "../../../pages/Tables/users.js";
import swal from "sweetalert2";
import Fuse from "fuse.js";
import NotificationHorarioLimite from "../../Notifications/NotificationHorarioLimite.vue";
import Modal from "@/components/Modal.vue";
import jwt from "jsonwebtoken";

export default {
  props: {
    nomeDep: {
      type: Object,
    },
  },
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    Modal,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      listDepartamentos: [],
      erros: {
        departamentos: "",
      },
      modalCopiarEscala: false,
      copiaEscalaSelecionada: "",
      copiaDepartamentosSelecionados: [],
      horarioSelecionado: "",
      adicionarModelo: false,
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0,
      },
      demitir: {
        data: "",
        motivo: "",
      },
      isLoading: false,
      dialogHorarioLimite: false,
      searchQuery: "",
      propsToSearch: ["descricao"],
      tableColumns: [
        {
          prop: "codigo",
          label: "Código",
          minWidth: 60,
        },
        {
          prop: "descricao",
          label: "Descrição",
          minWidth: 100,
        },
        {
          prop: "entrada_1",
          label: "Ent1",
          minWidth: 70,
        },
        {
          prop: "saida_1",
          label: "Saí1",
          minWidth: 70,
        },
        {
          prop: "entrada_2",
          label: "Ent2",
          minWidth: 70,
        },
        {
          prop: "saida_2",
          label: "Saí2",
          minWidth: 70,
        },
        {
          prop: "entrada_3",
          label: "Ent3",
          minWidth: 70,
        },
        {
          prop: "saida_3",
          label: "Saí3",
          minWidth: 70,
        },
        {
          prop: "entrada_4",
          label: "Ent4",
          minWidth: 70,
        },
        {
          prop: "saida_4",
          label: "Saí4",
          minWidth: 70,
        },
        {
          prop: "dias",
          label: "Dias",
          minWidth: 120,
        },
      ],
      tableData: users,
      searchedData: [],
      fuseSearch: null,
    };
  },
  mounted() {
    this.visualizarHorarios();
    this.listarDepartamentos();
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["descricao"],
      threshold: 0.3,
    });
  },
  methods: {
    notifyVue(verticalAlign, horizontalAlign) {
      this.$notify({
        component: NotificationHorarioLimite,
        icon: "tim-icons icon-bell-55",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "warning",
        timeout: 30000,
      });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    voltarF() {
      this.$root.$emit("voltarPesquisarEscalaDepartamento", 1);
    },

    visualizarHorarios() {
      // this.nomeDep = row.descricao
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_departamento: this.nomeDep.id,
      };
      this.axios
        .post("/api/escalas/listarModeloDeEscalas", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.data.status && response.data.data.dados.length) {
            th.tableData = response.data.data.dados.map((value) => {
              if (value.entrada_1) {
                value.entrada_1 = moment(value.entrada_1).format("HH:mm");
              }

              if (value.entrada_2) {
                value.entrada_2 = moment(value.entrada_2).format("HH:mm");
              }

              if (value.entrada_3) {
                value.entrada_3 = moment(value.entrada_3).format("HH:mm");
              }

              if (value.entrada_4) {
                value.entrada_4 = moment(value.entrada_4).format("HH:mm");
              }

              if (value.saida_1) {
                value.saida_1 = moment(value.saida_1).format("HH:mm");
              }

              if (value.saida_2) {
                value.saida_2 = moment(value.saida_2).format("HH:mm");
              }

              if (value.saida_3) {
                value.saida_3 = moment(value.saida_3).format("HH:mm");
              }

              if (value.saida_4) {
                value.saida_4 = moment(value.saida_4).format("HH:mm");
              }

              return value;
            });
          } else {
            th.tableData = [];
          }

          // th.tableData = response.data.data.dados
          th.itemMenu = 3;
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar departamentos!",
            "error",
          );
        });
    },

    handleEdit(index, row) {
      let w1 = jwt.sign({ data: { idModelo: row.id } }, "qXTflPwOaD", {
        expiresIn: "1h",
      });
      this.$router.push(`/editarEscalaDepartamento/${w1}`);
    },

    handleDelete(index, row) {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: row.id,
      };
      this.axios
        .post("/api/escalas/deletarModeloEscalasDepartamento", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.visualizarHorarios();
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Exclusão realizada com sucesso!",
            "success",
          );
          // th.tableData = response.data.data.dados
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar departamentos!",
            "error",
          );
        });
    },

    handleCopy(index, row) {
      this.copiaEscalaSelecionada = row;
      this.modalCopiarEscala = true;
      this.erros.departamentos = false;
      this.copiaDepartamentosSelecionados = [];
    },

    salvarCopiaEscala() {
      //validar departamentos
      if (this.copiaDepartamentosSelecionados.length == 0) {
        this.erros.departamentos = true;
      } else {
        this.erros.departamentos = false;
        const th = this;
        this.isLoading = true;
        const bodyFormData = {
          setDB: this.$cookies.get("db"),
          escala: this.copiaEscalaSelecionada,
          departamentos: this.copiaDepartamentosSelecionados,
        };

        this.axios
          .post(
            "/api/escalas/copiarModeloDeEscalasDepartamento",
            bodyFormData,
            {
              headers: {
                "id-actor": this.$cookies.get("id_actor"),
                "tipo-actor": this.$cookies.get("tipo_actor"),
              },
            },
          )
          .then((response) => {
            th.isLoading = false;
            th.copiaEscalaSelecionada = "";
            th.copiaDepartamentosSelecionados = [];
            th.modalCopiarEscala = false;
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Cópia de Escala realizada com sucesso!",
              "success",
            );
          })
          .catch((err) => {
            console.log(err);
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao tentar copiar Escala de Departamento!",
              "error",
            );
          });
      }
    },

    listarDepartamentos() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/departamento/listarDepartamentos", bodyFormData)
        .then((response) => {
          th.isLoading = false;
          th.listDepartamentos = response.data.data.dados.filter(
            (dp) => dp.id != this.nomeDep.id,
          );
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar departamentos!",
            "error",
          );
        });
    },
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
</style>
